/**
 * Supabase Auth — REST API ile (SDK yok).
 */

const URL = process.env.REACT_APP_SUPABASE_URL
const KEY = process.env.REACT_APP_SUPABASE_ANON_KEY
const STORAGE_KEY = 'replay_upload_session'

function authUrl(path) {
    return (URL || '').replace(/\/$/, '') + '/auth/v1' + path
}

export function isAuthConfigured() {
    return !!(URL && KEY)
}

export async function signIn(email, password) {
    if (!URL || !KEY) return { error: { message: 'Sunucu ayarlı değil' } }
    const res = await fetch(authUrl('/token?grant_type=password'), {
        method: 'POST',
        headers: {
            apikey: KEY,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: (email || '').trim(), password: password || '' }),
    })
    const data = await res.json()
    if (!res.ok) return { error: data || { message: 'Giriş başarısız' } }
    const session = {
        access_token: data.access_token,
        refresh_token: data.refresh_token,
        user: data.user,
        expires_at: data.expires_at,
    }
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(session))
    } catch (e) {}
    return { data: session, error: null }
}

export async function signUp(email, password) {
    if (!URL || !KEY) return { error: { message: 'Sunucu ayarlı değil' } }
    const res = await fetch(authUrl('/signup'), {
        method: 'POST',
        headers: {
            apikey: KEY,
            'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: (email || '').trim(), password: password || '' }),
    })
    const data = await res.json()
    if (!res.ok) return { error: data || { message: 'Kayıt başarısız' } }
    const session = {
        access_token: data.access_token,
        refresh_token: data.refresh_token,
        user: data.user,
    }
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(session))
    } catch (e) {}
    return { data: session, error: null }
}

export function getSession() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY)
        if (!raw) return null
        const s = JSON.parse(raw)
        if (s && s.access_token && s.user) return s
    } catch (e) {}
    return null
}

export function signOut() {
    try {
        localStorage.removeItem(STORAGE_KEY)
    } catch (e) {}
}



// WEBPACK FOOTER //
// ./src/lib/supabaseAuth.js